<template>
    <v-card class="text-center border border-transparent" outlined>
        <v-card-title class="justify-center font-weight-bold subtitle-2 text-uppercase">{{$t('sellerInformation')}}</v-card-title>
        <v-divider></v-divider>
        <v-container dense>
            <v-responsive  v-if="companyId">
                <router-link :to="companyLinkPrefix + companyId">
                    <v-avatar size="100">
                        <v-img :src="sellerAvatar" contain></v-img>
                    </v-avatar>
                </router-link>
            </v-responsive>

            <v-responsive v-if="!companyId">
                <v-avatar size="100">
                    <v-img :src="sellerAvatar">
                    </v-img>
                </v-avatar>
            </v-responsive>

            <v-card-text class="justify-center pb-0" v-if="companyId">
                <router-link
                        :to="companyLinkPrefix + companyId"
                        class="subtitle-2 black--text text-underline-hover"
                >{{ sellerName }}</router-link>
            </v-card-text>

            <v-card-text class="justify-center pb-0" v-if="!companyId">
                <span class="subtitle-2 black--text">{{ sellerName }}</span>
            </v-card-text>

            <v-card-text class="caption pb-1">В Agrolink {{$t('from')}} {{ sellerDate }}</v-card-text>
            <v-card-text class="subtitle-2 font-weight-light pb-1" v-if="selfShipment">
                <div>{{ $t('selfShipmentText1') }}</div>
                <div>{{ $t('selfShipmentText2') }}</div>
            </v-card-text>
            <v-card-actions class="d-flex justify-center" v-if="companyRate.value">
                <v-rating
                        :value="companyRate.value"
                        color="orange lighten-2"
                        dense
                        small
                        background-color="orange lighten-2"
                        readonly
                ></v-rating>
                <span class="orange--text text--lighten-2">( {{ companyRate.total }} )</span>
            </v-card-actions>
            <v-container dense flat class="px-4 pb-0">
                <v-divider></v-divider>
                <v-list></v-list>
                <v-btn
                        dark
                        depressed
                        class="px-6 subtitle-2"
                        color="main--yellow"
                        @click="authActionHandle({type: 'message'})"
                >
                    {{$t('write')}}
                </v-btn>

                <div v-if="contacts.length" class="pt-2">
                    <v-btn
                        text
                        small
                        class="text--main-yellow"
                        @click="dialog = true"
                    >
                        {{ $t('contacts') }}
                    </v-btn>
                </div>
            </v-container>
        </v-container>
        <contacts-dialog
            :is-open="dialog"
            :contacts="contacts"
            @close="dialog = false"
        ></contacts-dialog>
    </v-card>
</template>

<script>
    import ActionAccess from '../../../app-front/mixins/ActionAccess';
    import ContactsDialog from '../../../app-front/components/dialogs/ContactsDialog';

    export default {
        name: "SellerInfo",
        components: { ContactsDialog },
        props: ['productData', 'companyRate'],
        mixins:[ActionAccess],
        data() {
            return {
                companyLinkPrefix: '/companies/',
                dialog: false,
            }
        },
        computed: {
            sellerAvatar () {
                return this.productData.seller && this.productData.seller.image ? this.productData.seller.image : '/images/default-user.png';
            },
            sellerDate() {
                return this.productData.seller ? this.productData.seller.createdAt : '';
            },
            sellerName() {
                return this.productData.seller ? this.productData.seller.name : '';
            },
            companyId() {
                return this.productData.seller ? this.productData.seller.companyId : null;
            },
            selfShipment() {
              return this.productData.selfShipment ? this.productData.selfShipment : false;
            },
            contacts() {
                return this.productData.seller?.contacts || [];
            },
        },
        methods: {
            authSuccessActionHandle(data) {
                switch(data.type) {
                    case 'message' : this.$emit('message', { type: 'sellerMessage' }); break;
                }
            },
        },
    }
</script>

<style scoped>

</style>
